/**
 * Molecule — Badge + shared status→variant mapping for V2.
 *
 * **BUG-003 contract:** The visible label is the API value ({@link ../../core/statusDisplay.js getStatusDisplayLabel});
 * colors follow {@link ../../core/statusVariant.js getStatusVariant} on a normalized key so chips look consistent
 * even when payloads differ only by case or separators.
 */
import React from "react";
import styled from "styled-components";
import { Badge } from "../atoms/Badge";
import { theme } from "../theme/semanticTheme";
import { getStatusDisplayLabel } from "../../core/statusDisplay";
import { getStatusVariant } from "../../core/statusVariant";

const StatusBadgeWrap = styled(Badge)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: ${theme.typography.statusBadge.minWidth};
  max-width: 100%;
  padding: 2px 8px;
  font-size: ${theme.typography.statusBadge.fontSize};
  font-weight: ${theme.typography.statusBadge.fontWeight};
  line-height: ${theme.typography.statusBadge.lineHeight};
  text-align: center;
  white-space: normal;
  word-break: break-word;
`;

export default function StatusBadge({ status }) {
  const label = getStatusDisplayLabel(status);
  const variant = getStatusVariant(status);
  return <StatusBadgeWrap variant={variant}>{label}</StatusBadgeWrap>;
}
